import React, { useState } from "react";
import {
  Drawer,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Toolbar,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import { Link, matchPath, useLocation } from "react-router-dom";
import { Extension, Dashboard, LockRounded, FileCopy, MenuRounded } from "@material-ui/icons";

const drawerWidth = 200;

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
  },
  active: {
    color: theme.palette.primary.main,
  },
  navMenu: {
    position: "fixed",
    margin: "1rem",
    height: "3rem",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function SideNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const menuList = [
    {
      text: "Dashboard",
      icon: <Dashboard />,
      link: "/admin",
    },
    {
      text: "Search",
      icon: <SearchIcon />,
      link: "/admin/search",
    },
    {
      text: "Matches",
      icon: <Extension />,
      link: "/admin/matches",
    },
    {
      text: "Security",
      icon: <LockRounded />,
      link: "/admin/security",
    },
    {
      text: "Paper Registration",
      icon: <FileCopy />,
      link: "/admin/paper-registration",
    },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.navMenu}
        >
          <MenuRounded />
        </IconButton>
      )}
      <Drawer
        className={classes.drawer}
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List component="nav">
            {menuList.map((item, index) => {
              const { text, icon, link } = item;

              const isActive = matchPath(link, location.pathname)?.isExact;
              return (
                <ListItem button key={text} component={Link} to={link} className={isActive ? classes.active : ""}>
                  {icon && <ListItemIcon>{icon}</ListItemIcon>}
                  <ListItemText primary={text} />
                </ListItem>
              );
            })}
          </List>
        </div>
      </Drawer>
    </>
  );
}
